import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { TutorialService } from 'src/app/services/core/tutorials/tutorial.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';

@UntilDestroy()
@Component({
  selector: 'app-tutorials-list',
  templateUrl: './tutorials-list.component.html',
  styleUrls: ['./tutorials-list.component.css']
})
export class TutorialsListComponent implements OnInit {

  search: string = '';
  selectedStatus: boolean = true;
  status: boolean = true;
  currentPage = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  tutorialsList: any[] = [];
  filtertutorialsList: any[] = [];
  tutorialModalObj: any;
  userPermission = UserPermission;
  user:any;
  type: string = 'all';

  private readonly searchSubject = new Subject<string | undefined>();

  constructor(
    public permissionService: PermissionService,
    private tutorialService: TutorialService,
    private sharedDataService: SharedDataService,
  ) {}

  ngOnInit(): void {
    this.initializeSearch();
    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data:any) => {
      if (data) {
        this.user = data;
         this.getTutorials(this.currentPage);
      }
    })
  }

  getTutorials(page: number) {
    const queryparams: any = {
      page,
      limit: this.numberOfRecords,
      isActive: this.status,
      audience : this.user && this.user.role ? this.user.role.type : '',
    };

    if (this.type && this.type !== 'all') {
      queryparams.type = this.type;
    }

    if (this.search?.trim()) {
      queryparams.search = this.search.trim();
    }

    this.tutorialService.getTutorials(queryparams)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data: any) => {
          this.tutorialsList = data?.results || [];
          this.filtertutorialsList = data?.results || [];
          this.totalPages = data?.totalPages || 0;
          this.totalResults = data?.totalResults || 0; 
        },
        error: (err: any) => {
          console.error(err);
        }
      });
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3)
      )
      .subscribe(() => {
        this.currentPage = 1;
        this.getTutorials(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  onSelectStatus() {
    this.status = this.selectedStatus;
    this.currentPage = 1;
    this.getTutorials(this.currentPage);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getTutorials(page);
  }

  openTutorialEditModal(tutorial: any) {
    this.tutorialModalObj = tutorial;
  }

  onSaveTutorial(evt: any) {
    if (evt) {
      const idx = this.filtertutorialsList.findIndex((t: any) => t.id === evt.id);
      if (this.status === evt.isActive) {
        this.filtertutorialsList[idx] = evt;
      } else {
        this.filtertutorialsList.splice(idx, 1);
      }
    }
    this.tutorialModalObj = null;
  }

  onCloseTutorialModal() {
    this.tutorialModalObj = null;
  }

  onSelectType() {
    this.currentPage = 1;
    this.getTutorials(this.currentPage);
  }
}
